module.exports = __webpack_public_path__ + "img/dongji_ps_08.08cce013.jpg";